import type { IconData } from '@stacksjs/iconify-core'

export const userX: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M216 16a112.127 112.127 0 0 0-112 112v79.68a80.24 80.24 0 0 0 9.768 38.308l27.455 50.334L68.4 343.656A79.73 79.73 0 0 0 32 410.732V496h280v-32H64v-53.268a47.84 47.84 0 0 1 21.84-40.246l97.66-63.479l-41.64-76.341A48.15 48.15 0 0 1 136 207.68V128a80 80 0 0 1 160 0v79.68a48.14 48.14 0 0 1-5.861 22.985L248.5 307.007l63.5 41.276v-38.166l-21.223-13.8l27.454-50.334A80.2 80.2 0 0 0 328 207.68V128A112.127 112.127 0 0 0 216 16m267.314 339.314l-22.628-22.628L412 381.372l-48.686-48.686l-22.628 22.628L389.372 404l-48.686 48.686l22.628 22.628L412 426.628l48.686 48.686l22.628-22.628L434.628 404z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default userX
